<script>   
	import { onMount } from 'svelte';
	   
    let document_type;
	let document_number;

	var url=window.location.href;
	var arrayQuery = url.split('?'); 
	var  arrayQuery = arrayQuery[1];
	let textResponse="Procesando.....";



	async function sendQuery ()  {
		try {		
         const rawResponse = await fetch('https://cert-api.politicadeprivacidadsiidj.bvc.com.co/rest-tratamiento-datos-otp/gateway', {
         method: 'POST',
         headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
         },
        body: JSON.stringify({ query:arrayQuery })

        });
  
	    let content = await rawResponse.json();
	     if(content.code===400){
		  errorInitData(content);
	     } 
		 else
		 {

        changeView(content);
	     }
      } catch (err) {
		
		errorServer("Servidor no disponible intente de nuevo en unos minutos");
    
   }
   
  

  };

  function errorServer(message){
	console.log("Entro errorInitData"); 	
		textResponse=message;	
	
		
		let divResponse = document.getElementById("response");
		divResponse.style.display='block';
		
 }
  function errorInitData(json){
	console.log("Entro errorInitData"); 	
		textResponse=json.errores[0];	
	
		
		let divResponse = document.getElementById("response");
		divResponse.style.display='block';
		
 }

  
  async function sendStatus (value) {
		const res = await fetch('https://cert-api.politicadeprivacidadsiidj.bvc.com.co/rest-tratamiento-datos-otp/gateway', {
			method: 'POST',
			headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
			body: JSON.stringify({
				status:value,
				documentType :document_type[1],
				documentNumber:document_number[1]
			})
		})
		
		const json = await res.json();	
		getText(json)
	
		
	}
  function changeView(content){
	  
	   var   hashParams = content.data.split('&'); 
	  if(hashParams.length == 1 ){
		let element = document.getElementById("response");
		element.style.display='block'	
		getText(content);
		
	  }
	  else{
		
		let element = document.getElementById('inicial');
		element.style.display = 'block' ;
		getParams(content);
	  }	
 }
 
 function closeOneModal() {

// get modal
const modal = document.getElementById('disagree-modal');

// change state like in hidden modal
modal.classList.remove('show');
modal.setAttribute('aria-hidden', 'true');
modal.setAttribute('style', 'display: none');

 // get modal backdrop
 const modalBackdrops = document.getElementsByClassName('modal-backdrop');

 // remove opened modal backdrop
  document.body.removeChild(modalBackdrops[0]);
}
function closeAllModals() {

// get modals
const modals = document.getElementsByClassName('modal');

// on every modal change state like in hidden modal
for(let i=0; i<modals.length; i++) {
  modals[i].classList.remove('show');
  modals[i].setAttribute('aria-hidden', 'true');
  modals[i].setAttribute('style', 'display: none');
}

 // get modal backdrops
 const modalsBackdrops = document.getElementsByClassName('modal-backdrop');

 // remove every modal backdrop
 for(let i=0; i<modalsBackdrops.length; i++) {
   document.body.removeChild(modalsBackdrops[i]);
 }
}
function getText(json){
	let btn = document.getElementById('agree-btn');
	let btnDisagree = document.getElementById('disagree-btn');
	
	   if(json.data!=null){
		console.log("Entro getText normal");  
		textResponse=json.data;
		
		let divResponse = document.getElementById("response");
		divResponse.style.display='block'
		let divInicial = document.getElementById("inicial");
		divInicial.style.display='none'	
		
		   
		closeAllModals();
//
		
		}

		if(json.errores!=null) 
		{
			console.log("Entro getText errores"); 	
		textResponse=json.errores[0];				 
		btn.setAttribute('data-bs-target', "#agree-modal");
		btn.setAttribute('data-bs-toggle', "modal");
		
		btnDisagree.setAttribute("data-bs-target", "#agree-modal");
		btnDisagree.setAttribute("data-bs-toggle", "modal");
		btnDisagree.setAttribute("data-bs-dismiss", "modal");
		let modal = document.getElementById('agree-modal');     
		var modal2 = bootstrap.Modal.getOrCreateInstance(modal)

		
		modal2.show();
		}
}	

function getParams(content) {
  var   hashParams = content.data.split('&'); 
 
  var first_name = hashParams[0].split('=');
  document.getElementById('first_name').value = first_name[1].replaceAll('-', ' ');

  var last_name = hashParams[1].split('=');
  document.getElementById('last_name').value = last_name[1].replaceAll('-', ' ');

   document_type = hashParams[2].split('=');
  document.getElementById('document_type').value = document_type[1];

   document_number = hashParams[3].split('=');
  document.getElementById('document_number').value = document_number[1];

  var phone_number = hashParams[4].split('=');
  document.getElementById('phone_number').value = phone_number[1];

  var email = hashParams[5].split('=');
  document.getElementById('email').value = email[1];
  
}

function enable(id) {
 let element = document.getElementById(id);
 element.disabled=false;    
 element.style.cursor='pointer';    

}  
function disable(id) {
 let element = document.getElementById(id);
 element.disabled=true;    
 element.style.cursor='none'; 
   
}

function recaptchaCallback() {       
 enable('agree-btn');
 enable('disagree-btn');	

}

function recaptchaExpiry() {       
	disable('agree-btn');
	disable('disagree-btn');

}

onMount( () => {
 sendQuery();
 
})


const clickStatus = event => { 
  sendStatus(event.target.value);
}
window.recaptchaCallback = recaptchaCallback;
window.recaptchaExpiry = recaptchaExpiry;

</script>
   
<style>


@font-face {
    font-family: 'Nunito-Extra-Bold';
    src: url('/fonts/Nunito/static/Nunito-ExtraBold.ttf');
}
@font-face {
    font-family: 'Nunito-Regular';
    src: url('/fonts/Nunito/static/Nunito-Regular.ttf');
}
@font-face {
    font-family: 'Nunito-Bold';
    src: url('/fonts/Nunito/static/Nunito-Bold.ttf');
}


.text-regular {
    font-family: 'Nunito-Regular';
	color: #4d4651;	
	font-size: 14pt;	
	line-height:16.8pt ;
	text-align: justify;
}
.text-bold {
    font-family: 'Nunito-Bold';
	color: #4d4651;	
	font-size: 20pt;	
}
.input.text-regular{
	color: #cecece;
	font-size: 17pt;
}
.text-modal{
	font-family: 'Nunito-Regular';
	color: #4d4651;	
	font-size: 14pt;
	line-height: 21.6pt;
	margin-bottom: 0;
	margin-top: 29px;
}
.question{
	font-family: 'Nunito-Bold';
	color: #4d4651;	
	font-size: 14pt;
	line-height: 21.6pt;
	margin-bottom: 22px;
	
}
   .container-fluid {
	 
	 margin-right: auto;
	 margin-left: auto;
   }
   .row {
	 margin-right: -15px;
	 margin-left: -15px;
   }
   #custom{
	   text-align: -webkit-center;
   }

   .form-control:disabled {
    background-color: #FFFFFF;
   
}


.grad {
	background: -webkit-linear-gradient(to right, #073e74, #29b5ea);
	background: linear-gradient(to right, #073e74, #29b5ea); 
	border: 1px ;
    width: 109px;
	height: 40px;  

}

 .sizeLogo{
	 width:140px;
	 height: 45px;
	
 }

 .modal-dialog {
    min-height: calc(100vh - 60px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: auto;
}



.btn {  	
	color: #FFFFFF;
    
	
    
}
.custom-btn{
	font-family: 'Nunito-Regular';
    font-size: 15pt;
    line-height: 22px;
	width: 61px;
	height: 40px;
}

.margin-text {
    padding-top: 25px;
	padding-bottom: 36px;
	padding-right:1.5rem!important ;
	padding-left: 1.5rem!important;
}
.title{
	padding-top: 56px;
	padding-bottom: 0px;
	padding-right:1.5rem!important ;
	padding-left: 1.5rem!important;
	
}
.margin{
margin: 0;
}
:global(body){
	background-image: url("/images/fondo_pop-up_datospersonales.png");
	background-attachment: fixed;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        height: 100%;
    }


   .modal-body {
    
    padding:34px 1rem 30px 1rem;
	background-image: url('/images/fondo_aceptacion.png');
    background-repeat: no-repeat;
    background-size: cover;
}


.modal-dialog {
    max-width: 600px;
   
}

.catchap-margin{
  margin-top: 43px;
}
.buttons-form{
	margin-bottom: 43px;
	 margin-top: 43px;
}
.form-input{
	margin-right: 55px;
}
.button-modal{
	margin-right: 21px;
}
.button-modal-basico{
	margin-top: 20px;
}
.hidden{
	display: none;
}

</style>
 
	 
		  
	  
  
   <div class="container-fluid  ">
	<form class="form-inline">

		<div class="row title d-flex align-items-end">
			
			  <div class="col-sm-8  ">                  
				<p class="fw-bold text-bold margin">Términos de la autorización de tratamiento de datos personales</p>
			 </div>
			  <div class="col-sm-4 ">                  
			   <img src="images/Logo deceval_color_2.png" alt="" class="float-end sizeLogo margin-logo">
			 </div>
			

		</div>

		<div id="response" class="row  margin-text hidden"  >
		
			<div class="col-sm-12">
			   
				   <p class="fw-normal  text-regular">
                    {textResponse}	<br/> <br/>
					 <span class="question">¡Gracias!</span> 
				</p>
			</div>
		</div>
<div id="inicial" class="hidden"> 	
	<div class="form-group">
	   <div class="row  margin-text">
		
		   <div class="col-sm-12">
			  
				  <p class="fw-normal  text-regular">
					Declaro que en mi calidad de Emisor, Administrador y/o Depositante Directo al momento de administrar, crear o modificar usuarios a través de un User Manager, soy Responsable del tratamiento de los datos personales que recolecte de los Titulares que utilizarán este sistema. Esta información será tratada de acuerdo a las políticas de tratamiento de datos personales de <span class="question">deceval</span>  en OTP SIIDJ dando estricto cumplimiento a los principios establecidos en el Régimen Legal de Protección de Datos Personales. Así mismo, manifiesto tener y/o haber recolectado de los Titulares de la información, autorización expresa sobre sus datos para: (i) Hacer Tratamiento (ii) Realizar el mandato encomendado, (iii)Transmitirlos a nivel nacional e/o internacional a <span class="question"> deceval</span>, para ello se podrá subcontratar su almacenamiento y subtransmitir los datos recibidos a nivel nacional e/o internacional, con el fin de que <span class="question"> deceval </span>cumpla con su objeto social, así como sus obligaciones legales, contractuales y estratégicas, y (iv) Poner a disposición de los demás Emisores, Administradores y/o Depositantes Directos y autoridades competentes, la información requerida del Titular, preservando en todo caso la reserva legal de la misma.                      <br/> <br/>
					En este mismo, me comprometo con <span class="question">deceval</span> a informar las novedades de los Titulares, tales como, discusión, revocatoria de autorización, modificaciones, actualizaciones entre otras y declaro que se garantizará la confidencialidad, reserva profesional, seguridad, acceso, transmisión a terceros y la circulación restringida de dicha información, así como la conservación de los registros de la aceptación que obtuvo directamente del titular de los datos
			   </p>
		   </div>
	   </div>
	
	   <div class="row  row justify-content-md-center">
		   <div class="col-sm-4 px-3 ">
			   <label for="first_name" class="text-regular">Nombres</label>
			   <input class="form-control input text-regular" id="first_name" name="  " disabled="disabled"  size="30" type="text" />
		   </div>
		   <div class="col-sm-4 px-3">
			   <label for="last_name" class="text-regular">Apellidos</label>
			   <input class="form-control input text-regular" id="last_name" name="" disabled="disabled"  size="30" type="text" />
		   </div>
	   </div>
   
	   <div class="row justify-content-md-center ">
		   
		   <div class="col-sm-4 px-3 p-1">
			   <label for="document_type" class="text-regular">Tipo de documento</label>
			   <input class="form-control input text-regular" id="document_type" name=" "disabled="disabled" size="30" type="text" />
		   </div>
		   <div class="col-sm-4 px-3 p-1">
			   <label for="document_number" class="text-regular">Documento de identidad</label>
			   <input class="form-control input text-regular" id="document_number" name="   " disabled="disabled" size="30" type="text" />
		   </div>
	   </div>
   
	   <div class="row justify-content-md-center ">
		   <div class="col-sm-4 px-3 p-1">
			   <label for="phone_number" class="text-regular">Teléfono</label>
			   <input class="form-control input text-regular" id="phone_number" name="" disabled="disabled" size="30" type="text" />
		   </div>
		   <div class="col-sm-4 px-3 p-1">
			   <label for="email" class="text-regular">Correo electronico</label>
			   <input class="form-control input text-regular" id="email" name="  " disabled="disabled" size="30" type="text" />
		   </div>
	   </div>
	</div>

	   <!--recatchap-->
	   <div class="row justify-content-md-center catchap-margin" > 
		   <div class="col-sm-4 px-3  " id="custom">
	        <div class="g-recaptcha" data-sitekey="6LdofFoiAAAAANerJnoSq2hNSDqu9Weyn2KZq2QO"  data-callback="recaptchaCallback" data-expired-callback="recaptchaExpiry"  ></div>
	       
        </div>

	   
	   <div class=" row d-flex justify-content-center buttons-form "  >	
		
			  <button  disabled   on:click={clickStatus} value=1  type="button"    class="btn grad rounded-pill form-input"     id="agree-btn"  >Acepto</button>
			  <button  disabled  type="button" class="btn  rounded-pill  grad "    data-bs-toggle="modal" data-bs-target="#disagree-modal" id="disagree-btn"> Rechazo</button>   
			
	   </div>
	</div>	
	</form>
	
	






   </div>
 <!--modal disagree-->
   <div class="modal fade" id="disagree-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" >
	<div class="modal-dialog">
	  <div class="modal-content text-center">
		
		<div class="modal-body">
         
			 <div class="row justify-content-md-center">
				<img src="images/logo-deceval.png" alt="" class="float-end sizeLogo">
			
			
				<p class="text-modal">De no aceptar la presente autorización no será posible el<br/> acceso y/o registro del usuario al aplicativo SIIDJ<br/></p> <p class=" question"> ¿Desea continuar? </p>
			 
			  
			 </div>
			
			 <button   on:click={clickStatus} id="disagree-btn"   value=2   type="button" class="btn custom-btn  rounded-pill  grad button-modal" data-bs-dismiss="modal"  >Si</button>
			 <button type="button" class="btn custom-btn rounded-pill  grad" data-bs-dismiss="modal">No</button>
			
		 

		</div>
		
	  </div>
	</div>

	
  </div>
<!--modal agree en caso de  error response  -->
  <div class="modal fade" id="agree-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" >
	<div class="modal-dialog">
	  <div class="modal-content text-center">
		
		<div class="modal-body">         
			 <div class="row justify-content-md-center">
				<img src="images/logo-deceval.png" alt="" class="float-end sizeLogo">		
			
				<p class="text-modal"  >{textResponse}</p> 
				<button type="button" class="btn  rounded-pill  grad button-modal-basico" data-bs-dismiss="modal">Acepto</button>			  
			 </div>	 
		</div>
		
	  </div>
	</div>
	
  </div>

<!-- PRODUCCION 10/21/2022 v1 -->
